module.exports = __webpack_public_path__ + "75f8f35a510189987da6aeb50d102fe6.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/what-is-sms-service/what-is-sms-service-ja.html
// module id = 1981
// module chunks = 0